import { render, staticRenderFns } from "./table-view.vue?vue&type=template&id=5d81c59e&scoped=true"
import script from "./table-view.vue?vue&type=script&lang=js"
export * from "./table-view.vue?vue&type=script&lang=js"
import style0 from "./table-view.vue?vue&type=style&index=0&id=5d81c59e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d81c59e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d81c59e')) {
      api.createRecord('5d81c59e', component.options)
    } else {
      api.reload('5d81c59e', component.options)
    }
    module.hot.accept("./table-view.vue?vue&type=template&id=5d81c59e&scoped=true", function () {
      api.rerender('5d81c59e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CustomerViews/TrackCrates/table-view.vue"
export default component.exports